<template>
  <!-- Nothing to HTML -->
</template>
<script>
  // Direct notification to user.
  export default {
    name: 'comp-direct-message',
    props: ['channel', 'userId'],
    mounted () {
      const channel = pusher.subscribe('personal.' + this.userId);
      channel.bind(this.channel, (data) => {
        const message = data.data.message
        this.$notify.success({
          title: 'ข้อความจากระบบ',
          message: message,
          offset: 50,
          duration: 10000
        })
      })
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/DirectMessage.vue